import { useQueryApi } from 'utils/api'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { QueryApiConfig } from 'utils/api'

const API_KS_PATH = `${
  process.env.NEXT_PUBLIC_BCKS_USE_AMBASSADOR === 'true' ? '/guru' : ''
}/guru-ks/v1/ks`

export function useAPIGetKepalaSekolahEligibility(
  queryConfig: QueryApiConfig<IBCKSKepalaSekolahEligibility>['queryConfig'] = {}
) {
  return useQueryApi<IBCKSKepalaSekolahEligibility>(
    `${API_KS_PATH}/eligibility`,
    {
      queryConfig: {
        useErrorBoundary: false,
        ...queryConfig,
      },
    }
  )
}
